import React from "react";

/**
 * Simple root-level error boundary. Prevents a single component crash from
 * unmounting the whole app (which happened once in iteration 8 when Contact.jsx
 * threw ReferenceError and the landing page went blank).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Uncaught UI error:", error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-[#F5EFE6] flex items-center justify-center p-6">
        <div className="max-w-md text-center">
          <p className="overline text-[#B76E79]">Something went wrong</p>
          <h1 className="font-serif text-4xl md:text-5xl text-[#14100F] mt-4">
            We hit a bump.
          </h1>
          <p className="mt-4 text-[#3A322E]">
            Refresh the page — if it happens again, drop us a note at{" "}
            <a
              href="mailto:justina@walnutlakes.co.uk"
              className="link-underline text-[#14100F]"
            >
              justina@walnutlakes.co.uk
            </a>
            .
          </p>
          <button
            onClick={() => {
              this.reset();
              window.location.reload();
            }}
            className="btn-primary mt-8 font-brand tracking-[0.14em]"
          >
            Refresh
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
